import React from "react";
import "./footer.css";
import logo from "../../../assets/logo.png";
import indian from "../../../assets/indian.jpg";
import canadian from "../../../assets/canadian.jpg";
import american from "../../../assets/american.jpg";
import brazilian from "../../../assets/brazilian.jpg";
import mexican from "../../../assets/mexican.jpg";

export default class Footer extends React.Component {
  render() {
    return (
      <footer>
        <div className="footer-main">
          <div className="footer-info">
            <img src={logo} alt="logo" />
            <h3>
              TheoryDev is all about developing your dream to the reality!
            </h3>
          </div>
          <div className="otherpages">
          <a href="/term-and-conditions">Term And Conditions</a>
          <a href="/privacy-policy">Privacy & Policy</a>
          </div>
          <div className="footer-list">
            <h1>Contact</h1>
            <a href="tel:+918391076673">
              <i class="fas fa-phone-alt"></i>+91 8391076673
            </a>
            <a href="tel:+917044804030">
              <i class="fas fa-phone-alt"></i>+91 7044804030
            </a>
            <a href="mailto: contact@theorydev.com">
              <i class="fas fa-envelope-open"></i>contact@theorydev.com
            </a>
          </div>
        </div>

        <div className="social-media">
          <a href="https://www.facebook.com/Theorydev7">
            <i className="fab fa-facebook"></i>
          </a>
          <a href="https://www.instagram.com/theorydev?igshid=v0r6aik0140f">
            <i class="fab fa-instagram"></i>
          </a>
          <a href="https://www.linkedin.com/in/theory-dev-09a9201b7">
            <i class="fab fa-linkedin-in"></i>
          </a>
          <a href="https://twitter.com/theory_dev">
            <i class="fab fa-twitter"></i>
          </a>
          <a href="#">
            <i class="fab fa-pinterest-square"></i>
          </a>
        </div>
        <div className="countries">
          <img src={indian} alt="" />
          <img src={canadian} alt="" />
          <img src={american} alt="" />
          <img src={mexican} alt="" />
          <img src={brazilian} alt="" />
        </div>
        <div className="footer-bottom">
          <div className="line"></div>
          <div className="copyright"> ©2020-THEORY DEV ALL RIGHTS RESERVED</div>
        </div>
      </footer>
    );
  }
}
